export enum ResourceType {
  Asset,
  Attachment,
  FormFile
}
